"use strict";

exports.__esModule = true;
exports.TwitterImg = exports.LinkedinImg = exports.InstagramImg = exports.FacebookImg = void 0;
var IMAGE_BASE_URL = "https://gallery.getshoutout.com/assets/socialmedia/";
var FacebookImg = IMAGE_BASE_URL + "facebook.png";
exports.FacebookImg = FacebookImg;
var InstagramImg = IMAGE_BASE_URL + "instagram.png";
exports.InstagramImg = InstagramImg;
var LinkedinImg = IMAGE_BASE_URL + "linkedin.png";
exports.LinkedinImg = LinkedinImg;
var TwitterImg = IMAGE_BASE_URL + "twitter.png";
exports.TwitterImg = TwitterImg;